import { createSelector } from 'reselect';

import { MyStationsKeys } from '../constants/MyStations';

const getMyStationsState = state => (state.myStations ? state.myStations : state);

export const getMyStationsListConfig = createSelector(getMyStationsState, state =>
  state.get(MyStationsKeys.LIST_CONFIG),
);

export const getMyStationsListSort = createSelector(getMyStationsListConfig, listConfig =>
  listConfig.get(MyStationsKeys.LIST_SORT),
);

export const getMyStationsInitialSort = createSelector(getMyStationsListConfig, listConfig =>
  listConfig.get(MyStationsKeys.IS_INITIAL_SORT),
);

export const getMyStationsListFields = createSelector(getMyStationsListConfig, listConfig =>
  listConfig.get(MyStationsKeys.FIELD_VISIBILITY),
);

export const getMyStationsListIsDescending = createSelector(getMyStationsListConfig, listConfig =>
  listConfig.get(MyStationsKeys.IS_DESC),
);

export const getMyStationsDisplay = createSelector(getMyStationsState, state => {
  return state.get(MyStationsKeys.DISPLAY_TYPE);
});
